
import { LocationVarKey } from '@swivl-mono/types';
import { WorksheetComponent, WorksheetComponentType } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponent.Component';
import {
  WorksheetColumn,
  WorksheetLayout,
  WorksheetRow,
} from '../../../Components/Worksheets/Layout/Worksheet.Layout.Components';
import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { IS_NOT_EQUAL, IF_ANY, IF_ALL, IS_EQUAL } from '../../../Components/Worksheets/Types/Worksheet.Interface';
import FMSModel from '../../../Models/FMS/FMS.Model';
import { useEffect, useMemo } from 'react';
import {Section } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';


export default function LocationSubpageInformation() {
  const page = usePropertiesGetLocationIds();
  const {FMSs} = FMSModel.useState()
  useEffect(() => {
    FMSModel.load(false)
  }, [])
  const FMSOptions = useMemo(() => {
    if (!FMSs) return undefined;
    return FMSs.map(a => ({ label: a.name, value: String(a.id) }))
  }, [FMSs])

  return (
    <WorksheetLayout>
        <h4>Foundation Features</h4>
        <WorksheetRow>

        <WorksheetColumn>
        <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="swivl CRM"
            keyName={LocationVarKey.HasSwivlCRM}
          />
        <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Live Chat"
            keyName={LocationVarKey.HasLiveChat}
          />  
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Custom CTA Messages"
            keyName={LocationVarKey.HasCustomCTAMessage}
          />        
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="After Navigate Messages"
            keyName={LocationVarKey.HasAfterNavigate}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Don't require postal code in store lookup"
            hideIf={IS_EQUAL(LocationVarKey.HasSingleLocation,"1")}
            keyName={LocationVarKey.HasShowAllStores}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Inventory Carousel"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasFMS,"1")}
            keyName={LocationVarKey.HasInventoryCarousel}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.WebsiteProvider,"golocal")}
            label="GoLocal FID"
            keyName={LocationVarKey.GoLocalFID}
          />
          
        </WorksheetColumn>

        <WorksheetColumn>
          
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="FMS Integration Enabled"
            keyName={LocationVarKey.HasFMS}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.DROPDOWN}
            {...page}
            options={FMSOptions}
            label="FMS Integration"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasFMS,"1")}
            keyName={LocationVarKey.FMSIntegrationId}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SINGLE_LINE}
            {...page}
            label="FMS ID"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasFMS,"1")}
            keyName={LocationVarKey.FMSId}
          />
          
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="FMS Sync Enabled"
            keyName={LocationVarKey.FMSSyncEnabled}
          />
          
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.whichTier,"Engage")}>
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Gate Code Integration"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasFMS,"1")}
            keyName={LocationVarKey.HasGateCodeIntegration}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Unit Number Integration"
            hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasFMS,"1"), IS_EQUAL(LocationVarKey.WhichFMS,"DoorSwap")])}
            keyName={LocationVarKey.HasUnitNumberIntegration}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Account Balance Integration"
            hideIf={IS_NOT_EQUAL(LocationVarKey.HasFMS,"1")}
            keyName={LocationVarKey.HasAccountBalanceIntegration}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Account Number Integration"
            hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.HasFMS,"1"), IS_NOT_EQUAL(LocationVarKey.WhichFMS,"StorEdge")])}
            keyName={LocationVarKey.HasAccountNumberIntegration}
          />
          </Section> 
          
          
        </WorksheetColumn>
        
      </WorksheetRow>

      <Section {...page} hideIf={IF_ALL([IS_NOT_EQUAL(LocationVarKey.whichTier,"Innovator"), IS_NOT_EQUAL(LocationVarKey.whichTier,"Disruptor")])}>
      <h4>Innovator Features</h4>
      <WorksheetRow>
        <WorksheetColumn>
        <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Sequences (FMS+)"
            keyName={LocationVarKey.HasFMSPlus}
          />
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="Google Review Integration"
            keyName={LocationVarKey.HasGoogleReviewIntegration}
          />  
        </WorksheetColumn>
        <WorksheetColumn>
          <WorksheetComponent
            componentType={WorksheetComponentType.SWITCH}
            {...page}
            label="DaVinci Code Integration"
            hideIf={IS_NOT_EQUAL(LocationVarKey.WhichFMS,"StorEdge")}
            keyName={LocationVarKey.HasDaVinciCodeIntegration}
          />
        </WorksheetColumn>
      </WorksheetRow>
      </Section>
      
    </WorksheetLayout>
  );
}
